import {createNullableContext} from '../context';
import type {Root} from './Root';

export default createNullableContext<Root>();
